/* global axios */
import ApiClient from './ApiClient';

class ContactListsAPI extends ApiClient {
  constructor() {
    super('contact_lists', { accountScoped: true });
  }

  addContacts(listId, contactIds) {
    return axios.post(`${this.url}/${listId}/add_contacts`, {
      contact_ids: contactIds,
    });
  }

  removeContacts(listId, contactIds) {
    return axios.delete(`${this.url}/${listId}/remove_contacts`, {
      data: { contact_ids: contactIds },
    });
  }

  getContacts(listId, page = 1) {
    return axios.get(`${this.url}/${listId}/contacts`, {
      params: { page },
    });
  }
}

export default new ContactListsAPI();
